import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Check if running in Zoom client by checking user agent
const userAgent = navigator.userAgent || '';
const isInZoom = userAgent.includes('ZoomApps') || userAgent.includes('Zoom');

console.log('User Agent:', userAgent);
console.log('Is in Zoom:', isInZoom);

if (!isInZoom) {
  // Not in Zoom - show install message
  console.log('Not running in Zoom client - showing install message');
  ReactDOM.render(
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      padding: '20px',
      textAlign: 'center'
    }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '1rem', color: '#2D8CFF' }}>
        🌱 DataOffset Carbon Offset
      </h1>
      <p style={{ fontSize: '1.2rem', marginBottom: '2rem', maxWidth: '600px' }}>
        This app must be opened from within the Zoom desktop client or mobile app.
      </p>
      <a 
        href="/api/zoomapp/install"
        style={{
          padding: '12px 24px',
          backgroundColor: '#2D8CFF',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '8px',
          fontSize: '1rem',
          fontWeight: '500'
        }}
      >
        View Installation Instructions
      </a>
    </div>,
    document.getElementById("root")
  );
} else {
  // In Zoom - render the app
  ReactDOM.render(
    <React.StrictMode>
      <HashRouter>
        <App />
      </HashRouter>
    </React.StrictMode>,
    document.getElementById("root")
  );
}

// If you prefer BrowserRouter instead of HashRouter, use this:
// import { BrowserRouter } from 'react-router-dom';
// And replace <HashRouter> with <BrowserRouter>

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
